import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useCompanyNameFilter } from './useCompanyNameFilter';
import { PeriodSelector } from '../company/components/periodSelector';

export const CompanyNameFilter = ({
  value,
  companyNameIncluded,
  companyNamePeriod,
  setFilters,
  sharedList,
  orderBy,
}) => {
  const { formSchema, onSearchChange, onSubmit, companyNameIncludedOptions, getInitialValues } = useCompanyNameFilter({
    sharedList,
    orderBy,
    setFilters,
    companyNameIncluded,
    companyNamePeriod,
  });

  return (
    <Formik
      initialValues={getInitialValues(value, companyNameIncluded, companyNamePeriod)}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values, setFieldValue }) => (
        <Form>
          <FormikAutoSubmit />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Field
              name="companyName"
              label="Company"
              placeholder="Search to add"
              size="small"
              component={FormAsyncMultiSelect}
              loadOptions={onSearchChange}
              anchorToBody
            />
            <Field
              name="companyNameIncluded"
              component={FormExtraOptions}
              options={companyNameIncludedOptions}
              onChange={(option) => setFieldValue('companyNameIncluded', option)}
            />
            {values.companyNameIncluded?.value === 'specific_period' && (
              <PeriodSelector
                selected={values.companyNamePeriod}
                onSelect={(periodValues) => setFieldValue('companyNamePeriod', periodValues)}
              />
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

CompanyNameFilter.propTypes = {
  value: PropTypes.array,
  companyNameIncluded: PropTypes.object,
  companyNamePeriod: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
};

CompanyNameFilter.defaultProps = {
  value: [],
  companyNameIncluded: null,
  companyNamePeriod: null,
  sharedList: null,
  orderBy: 'count',
};
